import { ReactComponent as Arrow } from 'assets/icons/chevronBlue.svg'
import { selectAddress } from 'feature/addresses/redux/addressCreateSelector'
import { SavedAddress } from 'feature/addresses/redux/MyAddresses.api'
import { TSuggest } from 'feature/registration/types'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { ServiceCenterHeader } from 'feature/serviceCenters/components'
import { useGetServicesQuery } from 'feature/serviceCenters/redux/service.api'
import { SetPageTypeProps, TService } from 'feature/serviceCenters/types'
import { ControlsType, MarkType } from 'feature/YandexMap/types'
import { TPoint } from 'feature/YandexMap/types/TPoint'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useActions, useAppSelector } from 'store/hooks'
import { Button } from 'ui'
import { AddressSelectInput } from 'widget/AddressSelectInput'

import style from './SearchServiceCenter.module.scss'
import { FIAS_LEVEL } from 'constants/const'

// страница поиска сц по адресу
export function SearchServiceCenter({ setPageType }: SetPageTypeProps) {
  const screen = useScreen()
  const navigate = useNavigate()
  const { data } = useGetServicesQuery()

  const { inputSuggest } = useAppSelector(selectAddress)
  const {
    setUserGeo,
    setServiceMarks,
    clearInputAddress,
    setGeolocationSetting,
  } = useActions()
  const [firstRender, setFirstRender] = useState<boolean>(true)

  useEffect(() => {
    clearInputAddress()
    setGeolocationSetting({ changeInput: false })
    return () => {
      setGeolocationSetting({ changeInput: true })
    }
  }, [])

  useEffect(() => {
    if (data) {
      const mapMarks: TPoint[] = data?.map((service: TService) => {
        return {
          coordinates: [
            Number(service.coordinatesLatitude),
            Number(service.coordinatesLongitude),
          ],
          name: service.name,
          description: service.address || service.name,
          uuid: service.uuid,
        }
      })
      setServiceMarks(mapMarks)
    }
  }, [data])

  const navigateToService = (address: SavedAddress | TSuggest) => {
    setUserGeo({ address: address })
    navigate(
      `/servicecenters/user-address?geo-lat=${address.geoLat}&geo-lon=${address.geoLon}`,
    )
  }

  const handleClick = () => setPageType('services')

  useEffect(() => {
    if (firstRender) {
      setFirstRender(false)
      return
    }
    if (!inputSuggest || +inputSuggest.fiasLevel < FIAS_LEVEL) return

    navigateToService(inputSuggest)
  }, [inputSuggest])

  return (
    <>
      <ServiceCenterHeader
        handleClick={handleClick}
        className={style.serviceHeader}
      />
      <div className={style.userAddress}>
        {screen === ScreenEnum.desktop && (
          <YandexMap
            className={style.map}
            isMapClickable={true}
            marks={[MarkType.geolocationMark, MarkType.serviceMarks]}
            controls={[
              ControlsType.GeolocationControlUnit,
              ControlsType.ZoomControl,
            ]}
          />
        )}
        <div className={style.addressBlock}>
          <Button
            variant='text'
            onClick={() => setPageType('services')}
            className={style.backButton}
            data-testid='sc-address-back-btn'
          >
            <Arrow className='rotate180' />
            Назад
          </Button>

          <AddressSelectInput
            className={style.addressInput}
            onSelect={navigateToService}
            label='Адрес вашего объекта'
            required={false}
            userAddressClick={navigateToService}
          />
        </div>
      </div>
    </>
  )
}
